import { Box, Flex, useIsMobile } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { MapProvider } from '@tq/web-maps';
import { useMapPolygon } from 'api';
import { EastingNorthing } from 'pages';
import { useParams } from 'react-router-dom';
import { mapsApiKey, mapsApiUrl } from 'tools';
import { MapWithPolygon } from '../MapWithPolygon';
import { MapComponentProps } from './types';

export const MapComponent: React.FC<MapComponentProps> = ({
  showMap,
  handleTileLoadError,
  caseDetails,
}) => {
  const isMobile = useIsMobile();
  const { id } = useParams();
  const { data: polygonData } = useMapPolygon(+(id ?? 0));

  /* This defaulting to 0 isnt optimal with this solution the fall 
  back provided by the geoserver will not be utilised. */
  const defaultCenterMap: [number, number] = [
    caseDetails?.application?.easting ?? 0,
    caseDetails?.application?.northing ?? 0,
  ];

  const mapOverrides = {
    defaultCenter: defaultCenterMap,
    defaultZoom: 10,
  };

  const StyledMapCss = `
  height: 100%;
  width: 100%;
  @media only screen and (max-width: 768px) { 
    max-width: 95vw;
    margin: 0 auto;
  }
  .ol-scale-line-override {
    left: 80%;
  }
  .layer-toggle {
    text-align: right;
    @media only screen and (max-width: 768px) { 
      z-index: 2;
    }
  }
`;

  return (
    <Box
      display='flex'
      flexDirection={'column'}
      justifyContent={'space-evenly'}
      w={{ base: '100%', lg: '600px' }}
      mb={{ base: 16, lg: 0 }}
      sx={{
        '.ol-scale-line-override': {
          left: '80%',
        },
        '#styled-control-bar': {
          'pointer-events': 'none',
        },
        '#ol-control-bar': {
          'z-index': '2',
          alignSelf: 'stretch',
        },
      }}
    >
      {showMap && (
        <MapProvider
          apiUrl={mapsApiUrl}
          apiKey={mapsApiKey}
          onTileLoadError={handleTileLoadError}
          overrides={mapOverrides}
        >
          <Box sx={{ StyledMapCss }}>
            <MapWithPolygon geoJson={polygonData?.geoJson} displayLayerToggle />
          </Box>
        </MapProvider>
      )}
      {isMobile && (
        <Flex
          justifyContent='center'
          alignItems='center'
          bg={COLOURS.gray[200]}
          h='50px'
          mb={4}
        >
          <EastingNorthing caseDetails={caseDetails} />
        </Flex>
      )}
    </Box>
  );
};
